import { Link } from "react-router-dom";
import { RuneLogo } from "@/components/RuneLogo";

export const LandingFooter = ({ login }) => (
  <footer className="border-t border-[color:var(--rb-border)] py-10">
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 sm:flex-row sm:px-6">
      <div className="flex items-center gap-2.5">
        <RuneLogo className="h-6 w-6" />
        <span className="rb-display font-semibold text-[color:var(--rb-text)]">Runebox</span>
        <span className="text-xs text-[color:var(--rb-text-faint)]">&middot; A private, governed registry for Claude Code teams</span>
      </div>
      <div className="flex items-center gap-6 text-sm text-[color:var(--rb-text-faint)]">
        <a href="#how" className="hover:text-[color:var(--rb-text-dim)]">How it works</a>
        <a href="#offer" className="hover:text-[color:var(--rb-text-dim)]">Pricing</a>
        <a href="#faq" className="hover:text-[color:var(--rb-text-dim)]">FAQ</a>
        <Link to="/use-with-claude" className="hover:text-[color:var(--rb-text-dim)]">Use with Claude</Link>
        <Link to="/terms" className="hover:text-[color:var(--rb-text-dim)]">Terms</Link>
        <Link to="/privacy" className="hover:text-[color:var(--rb-text-dim)]">Privacy</Link>
        <button onClick={login} className="hover:text-[color:var(--rb-text-dim)]">Log in</button>
      </div>
    </div>
  </footer>
);
